module.exports = __webpack_public_path__ + "public/Icons/siteConfiguration.svg?440a8f9d";